import { render, staticRenderFns } from "./BattlesBetElement.vue?vue&type=template&id=48db47f0&scoped=true"
import script from "./BattlesBetElement.vue?vue&type=script&lang=js"
export * from "./BattlesBetElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesBetElement.vue?vue&type=style&index=0&id=48db47f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db47f0",
  null
  
)

export default component.exports